"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunaConference = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRenderer_1 = require("../render/CardRenderer");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const TileType_1 = require("../../TileType");
const CardRequirements_1 = require("../CardRequirements");
const Card_1 = require("../Card");
const Size_1 = require("../render/Size");
const Resources_1 = require("../../Resources");
const constants_1 = require("../../constants");
const Turmoil_1 = require("../../turmoil/Turmoil");
const TurmoilHandler_1 = require("../../turmoil/TurmoilHandler");
class LunaConference extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.LUNA_CONFERENCE,
            cardType: CardType_1.CardType.EVENT,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.MOON],
            cost: 5,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.party(PartyName_1.PartyName.SCIENTISTS)),
            metadata: {
                description: 'Requires that Scientists are ruling or that you have 2 delegates there. ' +
                    'Gain 2 M€ per road tile on the Moon. Gain 2M€ per colony tile on the Moon.',
                cardNumber: 'M58',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(2).slash().nbsp(Size_1.Size.SMALL).moonRoad().any.br;
                    b.megacredits(2).slash().nbsp(Size_1.Size.SMALL).moonColony().any.br;
                }),
            },
        });
    }
    ;
    canPlay(player) {
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        if (turmoil.parties.find((p) => p.name === PartyName_1.PartyName.SCIENTISTS)) {
            return turmoil.canPlay(player, PartyName_1.PartyName.SCIENTISTS);
        }
        return player.canAfford(player.getCardCost(this) + constants_1.SOCIETY_ADDITIONAL_CARD_COST);
    }
    play(player) {
        const moonRoadCount = MoonExpansion_1.MoonExpansion.tiles(player.game, TileType_1.TileType.MOON_ROAD, { surfaceOnly: true }).length;
        const moonColonyCount = MoonExpansion_1.MoonExpansion.tiles(player.game, TileType_1.TileType.MOON_COLONY, { surfaceOnly: true }).length;
        player.addResource(Resources_1.Resources.MEGACREDITS, (moonRoadCount + moonColonyCount) * 2, { log: true });
        TurmoilHandler_1.TurmoilHandler.handleSocietyPayment(player, PartyName_1.PartyName.SCIENTISTS);
        return undefined;
    }
}
exports.LunaConference = LunaConference;
//# sourceMappingURL=LunaConference.js.map